<template>
  <div class="common-container">
    <div class="detail">
      <div class="content">
        <div class="dc-left">
          <news-classify/>
        </div>
        <div class="dc-right">
          <div class="title">{{ detail.title }}</div>
          <div class="time">{{ detail.updateTime }}</div>
          <div class="dcr-content" v-html="detail.content"></div>
          <div class="prev-next">
            <div class="prev" @click="goPreNews">
              上一篇：
              <span>
                {{ detail.preNews && Object.keys(detail.preNews).length > 0 ? detail.preNews.title : '无' }}
              </span>
            </div>
            <div class="next" @click="goNextNews">
              下一篇：
              <span>
                {{ detail.nextNews && Object.keys(detail.nextNews).length > 0 ? detail.nextNews.title : '无' }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NewsClassify from "../components/Classify.vue";
import {getCity} from "@/utils/locate";

export default {
  name: "NewsDetail",
  components: {NewsClassify},
  data() {
    return {
      detail: {}
    }
  },
  computed: {
    city() {
      return getCity()
    }
  },
  watch: {
    '$route.query.newsId': {
      immediate: true,
      handler(val) {
        this.$request.get('/News/detail', {
          params: {
            newsId: val,
            areaId: this.city.areaId
          }
        }).then(res => {
          if (res.code === 0) {
            this.detail = res.data
          }
        })
      }
    }
  },
  methods: {
    /**
     * 上一篇
     */
    goPreNews() {
      if (this.detail.preNews && Object.keys(this.detail.preNews).length > 0) {
        this.$router.push(`/news/detail?newsId=${this.detail.preNews.newsId}`)
      }
    },
    /**
     * 下一篇
     */
    goNextNews() {
      if (this.detail.nextNews && Object.keys(this.detail.nextNews).length > 0) {
        this.$router.push(`/news/detail?newsId=${this.detail.nextNews.newsId}`)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.detail {
  width: 1200px;
  padding: 30px 0 60px 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  .content {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;

    .dc-left {
      display: flex;
      flex-direction: column;
    }

    .dc-right {
      flex: 1;
      width: 0;
      display: flex;
      flex-direction: column;
      background-color: #FFFFFF;
      padding: 20px;
      border-radius: 8px;

      .title {
        font-weight: bold;
        font-size: 24px;
        text-align: center;
      }

      .time {
        font-size: 14px;
        color: #6C6C6C;
        text-align: center;
        margin-top: 10px;
      }

      ::v-deep {
        .dcr-content {
          margin: 20px 0;

          img {
            width: 100%;
          }
        }
      }

      .prev-next {
        padding-top: 20px;
        border-top: 1px solid #D7D7D7;
        display: flex;
        flex-direction: column;

        .prev, .next {
          display: flex;
          flex-direction: row;
          align-items: center;
          color: #6C6C6C;
          font-weight: bold;
          font-size: 14px;

          span {
            color: #2D2D2D;
            flex: 1;
            width: 0;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            cursor: pointer;

            &:hover {
              text-decoration: underline;
            }
          }
        }

        .next {
          margin-top: 5px;
        }
      }
    }
  }
}
</style>